

(function () {
  'use strict';

  var MOBILE = '(max-width: 768px)';

  function buildSwiper(section) {
    var el = section.querySelector('.box-toppers__swiper');
    if (!el || typeof Swiper === 'undefined') return null;

    var instance = new Swiper(el, {
      slidesPerView: 1.715,
      spaceBetween: 10,

      observer: true,
      observeParents: true,
      observeSlideChildren: true,

      breakpoints: {
        480: { slidesPerView: 1.8, spaceBetween: 16 },
        600: { slidesPerView: 2.3, spaceBetween: 16 }
      }
    });

    /* Images inside slides usually finish loading after
       Swiper has already measured them */
    var imgs = el.querySelectorAll('img');
    var pending = imgs.length;

    if (pending) {
      imgs.forEach(function (img) {
        if (img.complete) {
          pending--;
          return;
        }
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      });
    }

    function done() {
      pending--;
      if (pending <= 0 && instance && !instance.destroyed) {
        instance.update();
      }
    }

    window.addEventListener('load', function () {
      if (instance && !instance.destroyed) instance.update();
    });

    return instance;
  }

  function initSection(section) {
    var instance = null;
    var mq = window.matchMedia(MOBILE);

    function sync() {
      if (mq.matches && !instance) {
        instance = buildSwiper(section);
      } else if (!mq.matches && instance) {
        // true, true = also strip the inline styles Swiper added
        instance.destroy(true, true);
        instance = null;
      }
    }

    sync();

    // addEventListener isn't supported on MediaQueryList in older Safari
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-box-toppers]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
